export default class CustomRates {
	id: string;

	name: string;

	baseCurrency: string;

	constructor(id: string, name: string, baseCurrency: string) {
		this.id = id;
		this.name = name;
		this.baseCurrency = baseCurrency;
	}
}
